import { bindable } from 'aurelia-framework';

class OdsPagination {
  @bindable end;
  @bindable start;
  @bindable total;
  @bindable hasNext;
  @bindable hasPrevious;
  @bindable onNextClick;
  @bindable onPreviousClick;
}

export { OdsPagination };
